import { Box, Button, Card, Grid2, styled, Typography } from '@mui/material';
import palette from '../../../../theme/colors-palette';

export const Root = styled(Card)(() => ({
  minWidth: '240px',
  maxWidth: '360px',
  marginBottom: '1rem',
  boxShadow:
    'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px',
  borderRadius: '1rem',
  '&:hover': {
    '& $cardHeader': {
      '& $img': {
        transform: 'scale(1.15)',
        transition: 'transform 0.3s',
      },
    },
    boxShadow:
      'rgba(0, 0, 0, 0.1) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px',
    transform: 'scale(1.02)',
    transition: 'transform 0.3s',
  },
}));

export const Overlay = styled(Grid2)(() => ({
  position: 'absolute',
  height: '100%',
  width: '100%',
  top: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.3)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const OverlayText = styled(Typography)(() => ({
  fontWeight: 'bold',
  marginRight: 'auto',
  display: 'flex',
  marginTop: 'auto',
  color: 'white',
  fontSize: '1.5rem',
  padding: '0.5rem 1rem',
}));

export const PriceWrapRed = styled(Typography)(() => ({
  textDecoration: 'line-through',
  backgroundColor: palette.utriper.orange,
  width: 'fit-content',
  padding: '4px 8px 2px 8px',
  fontWeight: 'bold',
  color: 'white',
  borderRadius: '0.5rem',
}));

export const PriceWrapGreen = styled(Box)(() => ({
  backgroundColor: palette.utriper.green,
  width: 'fit-content',
  padding: '4px 8px 2px 8px',
  color: 'white',
  borderRadius: '0.5rem',
  marginBottom: '0.5rem',
}));

export const ButtonWrap = styled(Button)(() => ({
  width: '100%',
  margin: '0.4rem',
  backgroundColor: palette.utriper.lightblue,
  color: 'white',
  '&:hover': {
    backgroundColor: palette.utriper.darkblue,
  },
}));
